import { AbstractControl, FormGroup, ValidatorFn } from '@angular/forms';

export class RequiredTrackerService {
  private form: FormGroup;
  private requiredControls: AbstractControl[] = [];

  constructor(form: FormGroup) {
    this.form = form;
    this.requiredControls = this.getRequiredControls();
  }

  public refresh(form?: FormGroup) {
    if (form) {
      this.form = form;
    }

    // const requiredNames = this.requiredControls
    //   .map((control) => this.getControlName(control))
    //   .filter((name): name is string => name !== null);

    // console.log('Required controls:', requiredNames);

    this.requiredControls = this.getRequiredControls();
  }

  private getRequiredControls(): AbstractControl[] {
    return Object.values(this.form.controls).filter((control) =>
      this.hasRequiredValidator(control),
    );
  }

  public getProgress(): number {
    if (this.requiredControls.length === 0) return 100;

    const validCount = this.requiredControls.filter(
      (control) =>
        control.valid && control.value !== null && control.value !== '',
    ).length;

    return Math.ceil((validCount / this.requiredControls.length) * 100);
  }

  public getControlName(control: AbstractControl): string | null {
    const parent = control.parent;

    if (!parent || !(parent instanceof FormGroup)) {
      return null;
    }

    return (
      Object.keys(parent.controls).find((key) => control === parent.get(key)) ||
      null
    );
  }

  private hasRequiredValidator(control: AbstractControl): boolean {
    const validator = control.validator;

    if (!validator) return false;

    const testResult = validator({ value: null } as AbstractControl);

    return (
      testResult?.['required'] !== undefined ||
      testResult?.['requiredTrue'] !== undefined
    );
  }
}
